/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCheckoutRedeliveryRequestCheckoutRedelivery } from './CreateCheckoutRedeliveryRequestCheckoutRedelivery';
import {
    CreateCheckoutRedeliveryRequestCheckoutRedeliveryFromJSON,
    CreateCheckoutRedeliveryRequestCheckoutRedeliveryFromJSONTyped,
    CreateCheckoutRedeliveryRequestCheckoutRedeliveryToJSON,
} from './CreateCheckoutRedeliveryRequestCheckoutRedelivery';

/**
 * 
 * @export
 * @interface CreateCheckoutRedeliveryRequest
 */
export interface CreateCheckoutRedeliveryRequest {
    /**
     * 
     * @type {CreateCheckoutRedeliveryRequestCheckoutRedelivery}
     * @memberof CreateCheckoutRedeliveryRequest
     */
    checkoutRedelivery: CreateCheckoutRedeliveryRequestCheckoutRedelivery;
}

/**
 * Check if a given object implements the CreateCheckoutRedeliveryRequest interface.
 */
export function instanceOfCreateCheckoutRedeliveryRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "checkoutRedelivery" in value;

    return isInstance;
}

export function CreateCheckoutRedeliveryRequestFromJSON(json: any): CreateCheckoutRedeliveryRequest {
    return CreateCheckoutRedeliveryRequestFromJSONTyped(json, false);
}

export function CreateCheckoutRedeliveryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckoutRedeliveryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkoutRedelivery': CreateCheckoutRedeliveryRequestCheckoutRedeliveryFromJSON(json['checkout_redelivery']),
    };
}

export function CreateCheckoutRedeliveryRequestToJSON(value?: CreateCheckoutRedeliveryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkout_redelivery': CreateCheckoutRedeliveryRequestCheckoutRedeliveryToJSON(value.checkoutRedelivery),
    };
}

